import React, { useMemo } from "react";
import { Container, Accordion } from "react-bootstrap";
import "./SellFaqSection.css";
import { FormatFaqAnswer } from "@/components/sell/utils/TextFormatter";
import SellPlusIcon from "../../../../public/assets/staticIcon/sellPlusIcon";
import SellMinusIcon from "../../../../public/assets/staticIcon/sellMinusIcon";

// Static FAQ data
const staticFaqData = {
  title: "Frequently Asked Questions",
  impInfo: "Important information about selling your property",
  "@nodes": ["faq1"],
};

const SellFaqSection = ({ cmsData = [] }) => {
  // Extracting FAQ questions safely, using static data as fallback
  const faqQuestions = cmsData?.[0]?.faqQuestions ?? staticFaqData;

  // Mapping over FAQ data safely
  const faqs = useMemo(() => {
    return (
      faqQuestions["@nodes"]?.map((key) => ({
        question: faqQuestions[key]?.ques || "No question available",
        answer: faqQuestions[key]?.answer || "No answer available",
      })) || []
    );
  }, [faqQuestions]);

  const handleNavigate = () => {
    window.location.href = cmsData[0]?.externalAppUrl || "";
  };

  return (
    <Container fluid className="sellFaqContainer">
      <p className="sellFaqNote">
        <strong>{faqQuestions?.impInfo}</strong>
      </p>
      <h2 className="sellFaqHeading">{faqQuestions?.title}</h2>
      <Accordion defaultActiveKey={null} className="sellFaqAccordian">
        {faqs.map((faq, index) => (
          <Accordion.Item eventKey={index.toString()} key={index}>
            <Accordion.Header className="sellAccordianHeader">
              <div>
                <SellPlusIcon className="sellPlusIcon" />
              </div>
              <div>
                <SellMinusIcon className="sellMinusIcon" />
              </div>
              <span className="sellFaqQues">{faq.question}</span>
            </Accordion.Header>
            <Accordion.Body className="sellAccordianBody">
              <FormatFaqAnswer
                answer={faq.answer}
                handleLinkClick={handleNavigate}
              />
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </Container>
  );
};

export default SellFaqSection;
